module.exports = __webpack_public_path__ + "h5/img/public.c7288fae.png";